module.exports = __webpack_public_path__ + "img/menu-right-accent-2.2d8424b4.svg";